"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import styles from "./Leaderboard.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { numberWithCommas } from "@/helpers/Helpers";
import Pagination from "../pagination/Pagination";
import { SortDirection } from "@/entities/ISort";
import { LeaderboardCollector } from "./LeaderboardCollector";
import { fetchNftTdhResults, PAGE_SIZE, NftTDHRanked, setScrollPosition } from "./NFTLeaderboard";
import { faSquareCaretUp, faSquareCaretDown } from "@fortawesome/free-solid-svg-icons";
interface Props {
  contract: string;
  nftId: number;
}
enum Sort {
  card_balance = "balance",
}
export default function MemeLabLeaderboard(props) {
  const $ = _c(55);
  const [page, setPage] = useState(1);
  const [totalResults, setTotalResults] = useState(0);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [leaderboard, setLeaderboard] = useState(t0);
  const [leaderboardLoaded, setLeaderboardLoaded] = useState(false);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      sort: Sort.card_balance,
      sort_direction: SortDirection.DESC
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [sort, setSort] = useState(t1);
  let t2;
  if ($[2] !== page || $[3] !== props.contract || $[4] !== props.nftId || $[5] !== sort.sort || $[6] !== sort.sort_direction) {
    t2 = async function fetchResults() {
      setLeaderboardLoaded(false);
      const response = await fetchNftTdhResults(props.contract, props.nftId, "", page, sort.sort, sort.sort_direction);
      setTotalResults(response.count);
      const data = response.data.map((lead, index) => {
        const rank = index + 1 + (page - 1) * PAGE_SIZE;
        return {
          ...lead,
          rank
        };
      });
      setLeaderboard(data);
      setScrollPosition();
      setLeaderboardLoaded(true);
    };
    $[2] = page;
    $[3] = props.contract;
    $[4] = props.nftId;
    $[5] = sort.sort;
    $[6] = sort.sort_direction;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const fetchResults = t2;
  let t3;
  if ($[8] !== fetchResults || $[9] !== page) {
    t3 = () => {
      if (page === 1) {
        fetchResults();
      } else {
        setPage(1);
      }
    };
    $[8] = fetchResults;
    $[9] = page;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== sort) {
    t4 = [sort];
    $[11] = sort;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  useEffect(t3, t4);
  let t5;
  if ($[13] !== fetchResults) {
    t5 = () => {
      fetchResults();
    };
    $[13] = fetchResults;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== page) {
    t6 = [page];
    $[15] = page;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  useEffect(t5, t6);
  let t7;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <th className={styles.memeLabRank}>Rank</th>;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== totalResults) {
    t8 = totalResults ? `x${totalResults.toLocaleString()}` : "";
    $[18] = totalResults;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t8) {
    t9 = <th className={styles.memeLabHodler}>Collector{" "}{t8}</th>;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setSort({
      sort: Sort.card_balance,
      sort_direction: SortDirection.ASC
    });
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const t11 = `${styles.caret} ${sort.sort_direction != SortDirection.ASC || sort.sort != Sort.card_balance ? styles.disabled : ""}`;
  let t12;
  if ($[23] !== t11) {
    t12 = <FontAwesomeIcon icon={faSquareCaretUp} onClick={t10} className={t11} />;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = () => setSort({
      sort: Sort.card_balance,
      sort_direction: SortDirection.DESC
    });
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  const t14 = `${styles.caret} ${sort.sort_direction != SortDirection.DESC || sort.sort != Sort.card_balance ? styles.disabled : ""}`;
  let t15;
  if ($[26] !== t14) {
    t15 = <FontAwesomeIcon icon={faSquareCaretDown} onClick={t13} className={t14} />;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t12 || $[29] !== t15) {
    t16 = <th className={`${styles.memeLabBalance} text-center`}><span className="d-flex align-items-center justify-content-center">Balance <span className="d-flex flex-column">{t12}{t15}</span></span></th>;
    $[28] = t12;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t16 || $[32] !== t9) {
    t17 = <tr>{t7}{t9}{t16}</tr>;
    $[31] = t16;
    $[32] = t9;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <tr className={styles.gap} />;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t17) {
    t19 = <thead>{t17}{t18}</thead>;
    $[35] = t17;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <tr className={styles.gap} />;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[38] !== leaderboard) {
    t21 = leaderboard.map(_temp);
    $[38] = leaderboard;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== t21) {
    t22 = <tbody>{t20}{t21}</tbody>;
    $[40] = t21;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] !== t19 || $[43] !== t22) {
    t23 = <Row className={styles.scrollContainer}><Col><Table bordered={false} className={styles.memeLabLeaderboardTable}>{t19}{t22}</Table></Col></Row>;
    $[42] = t19;
    $[43] = t22;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== page || $[46] !== totalResults) {
    t24 = totalResults > 0 && <Row className="text-center pt-2 pb-3"><Pagination page={page} pageSize={PAGE_SIZE} totalResults={totalResults} setPage={function (newPage) {
        setPage(newPage);
      }} /></Row>;
    $[45] = page;
    $[46] = totalResults;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  let t25;
  if ($[48] !== leaderboard.length || $[49] !== leaderboardLoaded) {
    t25 = leaderboardLoaded && leaderboard.length === 0 && <Row><Col>No Results found</Col></Row>;
    $[48] = leaderboard.length;
    $[49] = leaderboardLoaded;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] !== t23 || $[52] !== t24 || $[53] !== t25) {
    t26 = <Container className="no-padding" id="nft-leaderboard">{t23}{t24}{t25}</Container>;
    $[51] = t23;
    $[52] = t24;
    $[53] = t25;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  return t26;
}
function _temp(lead_0) {
  return <tr key={lead_0.consolidation_key}><td className={styles.rank}>{numberWithCommas(lead_0.rank)}</td><td className={styles.hodlerContainer}><div className={styles.hodler}><LeaderboardCollector handle={lead_0.handle} consolidationKey={lead_0.consolidation_key} consolidationDisplay={lead_0.consolidation_display} pfp={lead_0.pfp_url} cicType={lead_0.cic_type} level={lead_0.level} /></div></td><td className={styles.tdhSub}>{numberWithCommas(lead_0.balance)}</td></tr>;
}